module.exports = __webpack_public_path__ + "static/media/pe-beneficios.f24f2106.png";